<template>
    <div class="order-block">
        <div class="order-block__title"><span>Способ доставки:</span></div>
        <div class="order-block__content m-t-30">
            <fieldset class="form-group fieldset_vertical">
                <div v-for="deliveryType in dataList" :key="+deliveryType.ID" class="row">
                    <div class="col-5">
                        <label class="custom-control custom-radio">
                            <input :value="+deliveryType.ID" v-model="value" :name="inputName" type="radio"
                                   class="custom-control-input">
                            <span class="custom-control-indicator"></span>
                            <img :src="deliveryType.LOGOTIP_SRC" :alt="deliveryType.NAME" class="custom-control-logo">
                            <span class="custom-control-description">{{deliveryType.NAME}}</span>
                        </label>
                    </div>
                    <div v-if="deliveryType['PRICE']" class="col-2"><span
                            class="color-grey">{{deliveryType.price}}</span>
                    </div>
                    <div v-if="deliveryType && deliveryType.office_data && deliveryType.CHECKED === 'Y'" class="col-5">
                        <el-select v-model="subDelivery" placeholder="Выберите пункт выдачи" :valueKey="'id'">
                            <el-option
                                    v-for="subDeliveryItem in deliveryType.office_data"
                                    :key="subDeliveryItem.id"
                                    :label="subDeliveryItem.address_full"
                                    :value="subDeliveryItem.address_full">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </fieldset>
        </div>
    </div>
</template>

<script>
    export default {
      name: 'delivery-select',
      props: {
        dataList: {
          type: [Object, Array],
          default () {
            return {}
          }
        },
        defaultValue: {
          type: Number,
          default: 0
        }
      },
      created: function () {
        this.$emit('hasOffice', this.dataList[this.value] ? !!this.dataList[this.value].office_data : false)
      },
      data () {
        return {
          inputName: 'deliveryType',
          value: this.defaultValue,
          subDelivery: null
        }
      },
      watch: {
        value: function (value) {
          console.log(this.value)
          this.subDelivery = null
          this.$emit('select', value)
          this.$emit('hasOffice', !!this.dataList[value].office_data)
        },
        dataList: function (dataList) {
          console.log(dataList)
        },
        subDelivery: function (value) {
          this.$emit('subDeliveryChange', value)
        },
        defaultValue: function (value) {
          this.value = value
        }
      }
    }
</script>



// WEBPACK FOOTER //
// src/vue/components/order/components/EdostDelivery.vue